// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-checkbox {
  width: 100%;
  margin-bottom: 0px;
  border-radius: 5px;
  padding-left: 5px;
}

.table-checkbox:hover {
  background-color: #fff;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
